import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungFrankfurt() {
  return (
    <CityPageTemplate
      city="Frankfurt"
      slug="frankfurt"
      intro="In der Finanzhauptstadt Deutschlands setzen wir auf unabhängige Beratung statt Bankprodukte."
      description="Unabhängige & digitale Finanzberatung für Frankfurt: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
